import { render, staticRenderFns } from "./OesOtpLogin.vue?vue&type=template&id=17823b58&scoped=true&"
import script from "./OesOtpLogin.vue?vue&type=script&lang=js&"
export * from "./OesOtpLogin.vue?vue&type=script&lang=js&"
import style0 from "./OesOtpLogin.vue?vue&type=style&index=0&id=17823b58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17823b58",
  null
  
)

export default component.exports